import { render, staticRenderFns } from "./productFamilyView.vue?vue&type=template&id=7524324a&scoped=true&"
import script from "./productFamilyView.vue?vue&type=script&lang=js&"
export * from "./productFamilyView.vue?vue&type=script&lang=js&"
import style0 from "./productFamilyView.vue?vue&type=style&index=0&id=7524324a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524324a",
  null
  
)

export default component.exports